<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class="row" style="margin:10px">
          الأقساط ومتأخرات الصيانة
          <table width='100%' class='table  table-bordered ' >
            <thead>
              <tr>
                <th style='vertical-align: middle;padding:2px;text-align: center'>رقم العقد</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>ت. الاستحقاق</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>المبلغ</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>المدفوع</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>الباقى</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>متأخرات</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>متأخرات صيانة</th>
                <th style='vertical-align: middle;padding:2px;text-align: center'>المطلوب</th>
              </tr>
            </thead>
            <tbody>
              <tr :class="{highlight :selectedrec == record.contract_id}"  class='odd gradeX' v-for='record in installmentRecords' :key='record.contract_id'  v-on:click="showForm(record)">
                <td align='center' style="padding:2px">{{record.contract_id}}</td>
                <td align='center' style="padding:2px">{{record.due_date}}</td>
                <td align='center' style="padding:2px">{{record.total_amount}}</td>
                <td align='center' style="padding:2px">{{record.total_paid}}</td>
                <td align='center' style="padding:2px">{{record.rem}}</td>
                <td align='center' style="padding:2px">{{record.old}}</td>
                <td align='center' style="padding:2px">{{record.maintenance_ind}}</td>
                <td align='center' style="padding:2px">{{record.total_required}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class='col-lg-6 col-md-6'>
          <div class="col-lg-12 col-md-12" style="padding: 0px" >
            صيانة دورية
            <table width='100%' class='table  table-bordered '>
              <thead>
                <tr>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>الكود</th>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>الصنف</th>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>التاريخ الافتراضى</th>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>باقى يوم</th>
                </tr>
              </thead>
              <tbody>
                <tr :class="{highlight :selectedSubRec == record.id}" class='odd gradeX' v-for='(record,index) in maintenanceRecords' :key='index'  v-on:click="showSubForm(record)">
                  <td align='center' style="padding:2px">{{record.id}}</td>
                  <td v-show="record.offer_id > 0" align='right' style="padding:2px">{{record.item}} <code>{{itIsOffer}}</code></td>
                  <td v-show="record.offer_id === 0" align='right' style="padding:2px">{{record.item}}</td>
                  <td align='center' style="padding:2px">{{record.due_date}}</td>
                  <td align='center' style="padding:2px">{{record.rem}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-show="dataRecord.contract_id" class="col-lg-12 col-md-12 alert alert-info alert-dismissable" style="padding: 8px;0px;5px;0px" >
            <div class="col-lg-12 col-md-12">
              <label>العروض</label>
            </div>
            <table width='100%' class='table  table-bordered '>
              <thead>
                <tr>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>العرض</th>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>المبلغ</th>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>الأصناف</th>
                  <th style='vertical-align: middle;padding:2px;text-align: center'>الاجراء</th>
                </tr>
              </thead>
              <tbody>
                <tr class='odd gradeX' v-for='(record) in contractOffers' :key='record.id'>
                  <td align='center' style="padding:2px">{{record.offer_name}}</td>
                  <td align='right' style="padding:2px">{{record.price}}</td>
                  <td align='center' style="padding:2px">{{record.items}}</td>
                  <td align='center'>
                    <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <button  @click='deleteOffer(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-lg-9 col-md-9">
              <select  @change="chooseOffer($event.target.value)" class="form-control" style="padding: 0px" v-model="offer_id">
                <option  v-for="offer in offers" v-bind:key="offer.id"  v-bind:value="offer.id">
                  {{offer.offer_name}} - {{offer.price}}
                </option>
              </select>
            </div>
            <div v-show="offer_id > 0" class="col-lg-3 col-md-3" style="text-align:center;padding-top: 2px">
              <vue-element-loading size='32' :active='isLoadingSaveOffer' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveOffer'  type='button' class='btn btn-outline btn-sm btn-success'>إضافة</button>
            </div>
            <div v-show="offer_id > 0" class="col-lg-12 col-md-12" style="padding-top: 5px">
              <span  v-for="item in offerItems" :key="item.id">#{{item.item}} </span>
            </div>
          </div>
        </div>
        <div class='col-lg-6 col-md-6' style="padding-right:0px;padding-left:0px">
          <div class='col-lg-12 col-sm-12' style="padding-right:0px;padding-left:0px">
            <div class='form-group col-lg-3 col-sm-3' style="padding-right:0px">
              <span>الكود:</span>
              <input @keypress="isLocked($event)" v-model='dataRecord.id' class='form-control' name='branchname' type='text' style=" text-align: center" >
            </div>
            <div class='form-group col-lg-4 col-sm-4' style="padding-right:0px">
              <span>النوع:</span>
              <input @keypress="isLocked($event)" v-model='dataRecord.type' class='form-control' name='branchname' type='text' style=" text-align: center">
            </div>
            <div class='form-group col-lg-3 col-sm-3' style="padding-right:0px">
              <span>ت.أصلى:</span>
              <input @keypress="isLocked($event)" v-model='dataRecord.due_date' class='form-control' name='branchname' style=" text-align: center; padding-right:2px;padding-left:2px" type='text'>
            </div>
            <div class='form-group col-lg-2 col-sm-2' style="padding-right:0px;padding-left:0px">
              <span>التأجيل:</span>
              <input @keypress="isLocked($event)" v-model='dataRecord.delay' class='form-control' name='branchname' type='text'  style="text-align: center;">
            </div>
          </div>
          <div class='form-group col-lg-3 col-sm-3' style="padding-right:0px">
            <span>ت.حالى:</span>
            <input @keypress="isLocked($event)" v-model='dataRecord.currentDate' class='form-control' name='branchname' style=" text-align: center; padding-right:2px;padding-left:2px"  type='text'>
          </div>
          <div class='col-lg-3 col-sm-3' style="padding-right:0px">
            <span>الحالة:</span>
            <select  class="form-control" style="padding: 0px" v-model="action">
              <option  v-for="(action) in actions" v-bind:key="action.id"  v-bind:value="action.id">
                {{action.name}}
              </option>
            </select>
          </div>
          <div v-show="action === 1" class='col-lg-6 col-sm-6' style="padding:0px">
            <span>المحصل:</span>
            <select class="form-control" style="padding: 0px" v-model="collector">
              <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                {{ collector.name }}
              </option>
            </select>
          </div>
          <div v-show="action === 2" class='col-lg-2 col-sm-2' style="padding:0px">
            <span>الأيام</span>
            <select  class="form-control" style="padding: 0px" v-model="nums">
              <option  v-for="num in 31" v-bind:key="num"  v-bind:value="num">
                {{num}}
              </option>
            </select>
          </div>
          <div v-show="action === 2" class='col-lg-4 col-sm-4' style="text-align: center;padding:0px">
            <span align="center">ت.بعد التأجيل</span>
            <input @keypress="isLocked($event)" v-model='newDate' class='form-control' name='branchname' type='text'  style="text-align: center;">
          </div>
          <div class='col-lg-12 col-sm-12'  style="padding:0px">
            <div v-show="action === 1 && selectedrec === 0" class='col-lg-3 col-sm-3' style="padding:0px">
              <span>المبلغ: </span> <code v-show="dataRecord.offer_id > 0">{{itIsOffer}}</code>
              <input @keypress="isNumber($event)" v-model='price' class='form-control' name='branchname' type='text'  style="text-align: center;">
            </div>
          </div>
          <div class='col-lg-12 col-sm-12'  style="padding:0px">
            <span>ملاحظات:</span>
            <textarea class="form-control" rows="3" v-model="dataRecord.notes"></textarea>
          </div>
          <div class='col-lg-12 col-sm-12' style=' padding-top:5px; text-align:center;'>
            <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            <button @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          </div>
        </div>

        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import tbDate from '@/components/myComponents/tbDate'
import axios from 'axios'
export default {
  name: 'CollectingSheets',
  components: {
    tbDate
  },
  data () {
    return {
      validationErrors: '',
      dateFrom: '',
      dateTo: '',
      type: '',
      itIsOffer: 'عرض',
      installmentRecords: [],
      maintenanceRecords: [],
      offers: {},
      records: {},
      record: {},
      dataRecord: {},
      contractOffers: {},
      offerItems: {},
      action: 0,
      price: 0,
      offer_id: 0,
      nums: null,
      newDate: null,
      actions: [{id: 1, name: 'إضافة'}, {id: 2, name: 'تأجيل'}],
      collectors: {},
      collector: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingSaveOffer: false,
      isLoadingDelete: false,
      selectedrec: 0,
      selectedSubRec: 0,
      branches: {},
      Localcontract_id: 0
    }
  },
  watch: {
    nums (val) {
      var date = new Date(this.dataRecord.due_date)
      date.setDate(date.getDate() + val + this.dataRecord.delay)
      var dd = date.getDate()
      var mm = date.getMonth() + 1
      var y = date.getFullYear()
      this.newDate = y + '-' + mm + '-' + dd
    }
  },
  methods: {
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.offers = JSON.parse(localStorage.getItem('offers'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.collectors = this.branches[i].collectors
        this.stores = this.branches[i].stores
      }
    },
    chooseOffer (id) {
      let i = this.offers.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.offerItems = this.offers[i].offer_items
      }
    },
    saveOffer () {
      this.isLoadingSaveOffer = true
      axios.post(this.$apiURL + 'saveCustomerOffer', {
        token: localStorage.getItem('token'),
        contract_id: this.dataRecord.contract_id,
        offer_id: this.offer_id
      })
        .then(res => {
          this.isLoadingSaveOffer = false
          this.contractOffers = res.data
          this.success = 'تم إضافة العرض بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSaveOffer = false
        })
    },
    getOffers () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get_contract_offers', {
        token: localStorage.getItem('token'),
        contract_id: this.dataRecord.contract_id
      })
        .then(({ data }) => {
          this.contractOffers = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    deleteOffer (id) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'delete_contract_offer', {
        token: localStorage.getItem('token'),
        offer_id: id,
        contract_id: this.dataRecord.contract_id
      })
        .then(({ data }) => {
          this.contractOffers = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData (fromDate, toDate) {
      this.dateFrom = fromDate
      this.dateTo = toDate
      this.offer_id = ''
      this.action = ''
      this.selectedrec = 0
      this.selectedSubRec = 0
      this.installmentRecords = []
      this.maintenanceRecords = []
      this.dataRecord = []
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      // ==================================================
      let old = 0
      this.type = ''
      let getRecord = false
      this.$store.state.customerData.contract.forEach((contract) => {
        old = 0
        getRecord = false
        contract.payments.forEach((installment) => {
          if (installment.due_date < fromDate && installment.amount !== installment.total_paid) {
            old = old + installment.amount - installment.total_paid
          }
        })
        // ---------------------------------------------
        contract.payments.forEach((installment) => {
          if (installment.currentDate >= fromDate && installment.currentDate <= toDate && getRecord === false) {
            let newRec = {
              'contract_id': contract.id,
              'id': installment.id,
              'due_date': installment.due_date,
              'currentDate': installment.currentDate,
              'total_amount': installment.amount,
              'total_paid': installment.total_paid,
              'rem': installment.amount - installment.total_paid,
              'delay': installment.delay,
              'old': old,
              'type': 'قسط',
              'typeID': 1,
              'notes': installment.notes,
              'maintenance': [],
              'maintenance_ind': contract.maintenance_ind,
              'total_required': (installment.amount - installment.total_paid) + old + contract.maintenance_ind
            }
            this.installmentRecords.unshift(newRec)
            getRecord = true
          }
        })
        // hear if add empty record this is the code you can chack if empty 'old' and 'contract.maintenance_ind'
        if (getRecord === false && (contract.maintenance_ind > 0 || old > 0)) {
          if (old === 0) {
            this.type = 'صيانة'
          } else {
            this.type = 'عدة أقساط'
          }
          let newRec = {
            'contract_id': contract.id,
            'id': 0,
            'due_date': '',
            'currentDate': '',
            'total_amount': '',
            'total_paid': '',
            'rem': '',
            'type': this.type,
            'typeID': 1,
            'old': old,
            'delay': 0,
            'maintenance_ind': contract.maintenance_ind,
            'total_required': old + contract.maintenance_ind,
            'notes': '',
            'maintenance': []
          }
          this.installmentRecords.unshift(newRec)
        }
        // ----------  No inatallments No ind just Scheduled maintenance -----------------------------------
        if (getRecord === false && (contract.maintenance_ind === 0 && old === 0)) {
          let newRec = {
            'contract_id': contract.id,
            'id': 0,
            'due_date': '',
            'currentDate': '',
            'total_amount': '',
            'total_paid': '',
            'rem': '',
            'type': 'صيانة فقط',
            'typeID': 1,
            'old': old,
            'delay': 0,
            'maintenance_ind': contract.maintenance_ind,
            'total_required': old + contract.maintenance_ind,
            'notes': '',
            'maintenance': []
          }
          this.installmentRecords.unshift(newRec)
        }
        // ---------------------------------------------
        contract.maintenance.forEach((maintenance) => {
          if (maintenance.status === 0 && maintenance.currentDate <= toDate + 15 && maintenance.change_date === null) {
            const serverDate = new Date(maintenance.currentDate)
            const myDate = new Date()
            const difference = serverDate - myDate
            let maintenanceRec = {
              'contract_id': contract.id,
              'due_date': maintenance.default_date,
              'id': maintenance.id,
              'delay': maintenance.delay,
              'type': 'صيانة',
              'typeID': 2,
              'item': maintenance.item,
              'price': maintenance.price,
              'default_price': maintenance.default_price,
              'offer_id': maintenance.offer_id,
              'currentDate': maintenance.currentDate,
              'rem': Math.ceil(difference / (1000 * 60 * 60 * 24)),
              'notes': maintenance.notes
            }
            let i = this.installmentRecords.map(installmentRecord => installmentRecord.contract_id).indexOf(contract.id)
            if (i === -1) {

            } else {
              this.installmentRecords[i].maintenance.unshift(maintenanceRec)
            }
          }
        })
      })
      // ==================================================
      this.records = this.$store.state.customerData.receipt
      this.UpdateData(this.$store.state.customerData.branche_id)
      this.record = {}
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    showForm (recID) {
      this.selectedSubRec = 0
      this.maintenanceRecords = recID.maintenance
      this.selectedrec = recID.contract_id
      this.dataRecord = recID
      this.getOffers()
    },
    showSubForm (recID) {
      this.selectedrec = 0
      this.selectedSubRec = recID.id
      this.dataRecord = recID
      if (this.dataRecord.offer_id > 0) {
        this.price = this.dataRecord.default_price
      } else {
        this.price = this.dataRecord.price
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'addToCollectingStatement', {
        token: localStorage.getItem('token'),
        id: this.dataRecord.id,
        typeID: this.dataRecord.typeID,
        notes: this.dataRecord.notes,
        action: this.action,
        nums: this.nums + this.dataRecord.delay,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        collector: this.collector,
        contract_id: this.dataRecord.contract_id,
        price: this.price
      })
        .then(res => {
          this.isLoadingSave = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CollectingSheets.vue